import { computed } from 'mobx';
import ApiModel     from './globals/ApiModel';

export default class StandDocumentMediaStatusModel extends ApiModel {
  static get path() {
    return '/backend/stand_document_media_statuses/{?id}';
  }

  @computed
  get label(): string {
    return this.get('label');
  }

  @computed
  get reference(): string {
    return this.get('reference');
  }
}
